exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:768px){.fleetware-logo img[data-v-40274478]{margin-right:0}}", ""]);

// exports
